import { isLocalUrl } from './../utils/handleAttributes';

export default function seoWidget(
  widgetNameVariable,
  widgetOptsVariable,
  showButton,
  seoMainHeading,
) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = `${widgetName}-container`;

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];
    const localUrl = isLocalUrl(URL) ? '' : 'target="_blank"';

    $seo.replaceWith(`
      ${seoMainHeading.seoMainHeading ? `<h1 class="seo-title">${Title}</h1>` : `<h2 class="seo-title">${Title}</h2>`}

      <div class="seo-description">${Description}</div>
      ${showButton.showButton && URL ? `<a href="${URL}" class="button seo-button" ${localUrl}>Learn More</a>` : ''}
    `);
  }
}
